export default "__VITE_ASSET__BYp64Yjl__"